import { render, staticRenderFns } from "./addressManagement.vue?vue&type=template&id=6e55fce3&scoped=true&"
import script from "./addressManagement.vue?vue&type=script&lang=ts&"
export * from "./addressManagement.vue?vue&type=script&lang=ts&"
import style0 from "./addressManagement.vue?vue&type=style&index=0&id=6e55fce3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e55fce3",
  null
  
)

export default component.exports